import { render } from "./CloseCard.vue?vue&type=template&id=73402d61&scoped=true"
const script = {}

import "./CloseCard.vue?vue&type=style&index=0&id=73402d61&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73402d61"]])

export default __exports__